import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export function useActiveSubscription() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["active-subscription", user?.id],
    enabled: !!user,
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from("subscriptions")
        .select("*, billing_plans(*)")
        .eq("user_id", user!.id)
        .in("status", ["active", "trialing"])
        .gt("current_period_end", new Date().toISOString())
        .order("created_at", { ascending: false })
        .limit(1)
        .maybeSingle();
      if (error) throw error;
      return data as any;
    },
  });
}

export function useIsPro() {
  const { data } = useActiveSubscription();
  const slug = data?.billing_plans?.slug as string | undefined;
  return slug === "shareholder_pro" || slug === "partner_hub_pro";
}

export function useIsPartnerPro() {
  const { data } = useActiveSubscription();
  return data?.billing_plans?.slug === "partner_hub_pro";
}